export default __webpack_public_path__ + "video/forecasting.webm";